import { PromoButton } from 'web-ui-components/lib/navigation/buttons';

const PersonalTilesVM = [
  {
    labelText: 'Current accounts',
    link: '{bankUrl}/current-accounts/pca/apply/',
    type: PromoButton.CurrentAccounts,
  },
  {
    labelText: 'Savings',
    link: '{bankUrl}/savings/',
    type: PromoButton.Savings,
  },
  {
    labelText: 'Credit cards',
    link: '{bankUrl}/virgin/credit-cards/',
    type: PromoButton.CreditCards,
  },
];

const businessTilesVM = [
  {
    labelText: 'Business current accounts',
    link: '{bankUrl}/business/current-accounts/',
    type: PromoButton.BusinessBanking,
  },
  {
    labelText: 'Business Finance',
    link: '{bankUrl}/business/finance/',
    type: PromoButton.Loans,
  },
  {
    labelText: 'Savings',
    link: '{bankUrl}/business/savings/',
    type: PromoButton.Savings,
  },
  {
    labelText: 'International services',
    link: '{bankUrl}/business/international-services/',
    type: PromoButton.International,
  },
  {
    labelText: 'Risk management',
    link: '{bankUrl}/business/risk-management-solutions/',
    type: PromoButton.RiskManagement,
  },
];

class ProductPageUtils {
  static getProductList(isPersonalProduct) {
    return isPersonalProduct ? PersonalTilesVM : businessTilesVM;
  }
}

export default ProductPageUtils;
